import { createFromIconfontCN } from '@ant-design/icons';

// cqb 自定义图标
// const MyIcon = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/font_2049402_gtes6lrn6ww.js', // cqb 在 iconfont.cn 上生成 离线项目可以生成本地的
// });
//本地方式
const MyIcon = (props) => {
  return <i className={`iconfont ${props.type}`} style={{ paddingRight: '8px', ...props.style }}></i>
}
export default MyIcon